import dayjs from 'dayjs';
import { v4 as uuid } from 'uuid';

import { logService } from '../../../api';
import type { AdLog } from './types';

interface LogParam {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  analytics: { [key: string]: any };
}

class AdLogger {
  private buffer: AdLog[] = [];
  private maxBufferLength = 30;
  private maxBufferTime = 5000;
  private timeoutId: number | undefined;

  constructor() {
    this._scheduleFlush();

    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flush();
      }
    });
  }

  public log({ analytics }: LogParam) {
    this.buffer.push({
      log_id: uuid(),
      occurred_at: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
      goods_sno: analytics.goods_sno,
      list_id: analytics.list_id,
      action: analytics.action,
      campaign_id: analytics.campaign_id,
      parameters: analytics.parameters,
    });

    if (this.buffer.length < this.maxBufferLength) {
      return;
    }

    this.flush();
  }

  public async flush() {
    if (this?.buffer?.length === 0) {
      return;
    }

    const buffer = this.buffer;
    this.buffer = [];

    clearTimeout(this.timeoutId);

    await logService.postAdLog(buffer);

    this._scheduleFlush();
  }

  private _scheduleFlush() {
    // eslint-disable-next-line no-restricted-syntax -- 웹 전용 로거 (.web.ts)
    this.timeoutId = window.setInterval(() => {
      this.flush();
    }, this.maxBufferTime);
  }
}

export const adLogger = new AdLogger();
